import styled from "styled-components";

export const ContainerMenu = styled.div`
  display: inline-block;
  position: fixed;
  z-index: 9999;
  background: linear-gradient(360deg, #001019 18.65%, #014e7a 76.55%);
  right: ${({ $showBurguerMobile }) => (!$showBurguerMobile ? "-100vw" : "0")};
  top: 0;
  width: 30%;
  height: 100vh;
  transition: 0.5s ease-in-out;
  overflow: hidden;
  .fondo-abm {
    width: 100vw;
    height: 100vh;
    height: 100dvh;
    position: fixed;
    right: 0;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: -1;
    display: ${({ $showBurguerMobile }) =>
      !$showBurguerMobile ? "none" : "0"};
  }
  .line-white {
    width: 100%;
    height: 2px;
    background-color: var(--color-white);
  }
  @media (max-width: 1024px) {
    width: 80%;
  }
`;

export const TopMenu = styled.div`
  position: relative;
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: center;
  border-bottom: 2px solid var(--color-white);
  padding: 10px;
  .cruz-nueva-mitad {
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--color-white);
    width: 10%;
    min-width: 48px;
    min-height: 48px;
    position: relative;
    cursor: pointer;
    &::after {
      content: "";
      position: absolute;
      inset: -14px;
    }
  }
  .texto-mitad {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 90%;
  }

  ${({ $isIos }) =>
    $isIos === true
      ? `padding-top: 50px;
              height: 140px;
             `
      : ``};
`;

export const Image = styled.img`
  width: 64px;
  height: 64px;
  object-fit: cover;
  border-radius: 90%;
`;

export const TextTopMenu = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
`;

export const BodyMenu = styled.div`
  width: 100%;
  height: calc(100vh - 100px);
  height: calc(100dvh - 100px);
  margin: auto;
  overflow: scroll;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /* width */
  ::-webkit-scrollbar {
    width: 0;
  }
  .selected {
    background-color: #ff6600;
  }
  .ptur-socialSidebar-burguer {
    width: 100%;
    position: initial;
    padding: 20px 0;
  }
`;

export const ComboMenu = styled.div`
  ul {
    list-style: none;
    margin: auto;
    li {
      a {
        display: flex;
        align-items: center;
        text-decoration: none;
        gap: 10px;
        color: var(--color-white);
        min-height: 48px;
        position: relative;
        &::after {
          content: "";
          position: absolute;
          inset: -4px -10px;
        }
      }
      padding: 10px;
      padding-left: 40px;
    }
  }
  h1 {
    color: var(--color-white);
    font-size: 20px;
    margin-left: 20px;
  }
`;

export const FooterMenu = styled.div`
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: red;
  position: absolute;
  bottom: 0;
  left: 0;
`;
